'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonSubtitleStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /** Define button's size */
  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),

  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  size: 'normal'
}; // PROP RECEIVERS

var subtitleSizeProps = function subtitleSizeProps(_ref) {
  var size = _ref.size,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.button.size[size],
      subtitleFontSize = _theme$reactackle$com.subtitleFontSize,
      subtitleLineHeight = _theme$reactackle$com.subtitleLineHeight;
  var _theme$reactackle$com2 = theme.reactackle.components.button.subtitle,
      fontWeight = _theme$reactackle$com2.fontWeight,
      textTransform = _theme$reactackle$com2.textTransform,
      fontColor = _theme$reactackle$com2.fontColor,
      fontOpacity = _theme$reactackle$com2.fontOpacity,
      subtitleTitleSpacing = _theme$reactackle$com2.subtitleTitleSpacing;
  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(subtitleFontSize) + ';\n    line-height: ' + subtitleLineHeight + ';\n    font-weight: ' + fontWeight + ';\n    text-transform: ' + textTransform + ';\n    color: ' + fontColor + ';\n    opacity: ' + fontOpacity + ';\n    margin-bottom: ' + (0, _reactackleCore.getValueString)(subtitleTitleSpacing) + ';\n  ';
};

var ButtonSubtitleStyled = exports.ButtonSubtitleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ButtonSubtitleStyled'
})(['', ';color:inherit;'], subtitleSizeProps);

ButtonSubtitleStyled.propTypes = propTypes;
ButtonSubtitleStyled.defaultProps = defaultProps;
ButtonSubtitleStyled.displayName = 'ButtonSubtitleStyled';